// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Mgh7u","title":"Images45_title__1AwK-","images":"Images45_images__2pA_b"};